"use strict";
'kiwi public';

/* eslint-disable max-len */
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _TextFormatting = require("@/helpers/TextFormatting");
var _MessageInfo = _interopRequireDefault(require("./MessageInfo"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _MediaViewer = _interopRequireDefault(require("./MediaViewer"));
var profileEmojis = ['🛡', '⭐', '🕺', '🌸', '🌈', '🙂'];
var methods = {
  props: {},
  showRealName: function showRealName() {
    var props = this.props;
    if (!props.ml.buffer.setting('show_realnames')) {
      return false;
    }
    var client = props.ml.buffer.getNetwork().ircClient;
    if (!client.network.cap.isEnabled('extended-join')) {
      return false;
    }
    if (!props.message.user || !props.message.user.realname) {
      return false;
    }
    var realname = this.cleanVisibleRealName(props.message.user.realname);
    if (!realname) {
      return false;
    }
    if (props.message.user.nick.toLowerCase() === realname.toLowerCase()) {
      return false;
    }
    if (_TextFormatting.urlRegex.test(realname)) {
      return false;
    }
    return true;
  },
  getNetwork: function getNetwork() {
    var props = this.props;
    return props.ml.buffer.getNetwork();
  },
  isRepeat: function isRepeat() {
    return false;
  },
  isHoveringOverMessage: function isHoveringOverMessage(message) {
    var props = this.props;
    return message.nick && message.nick.toLowerCase() === props.ml.hover_nick.toLowerCase();
  },
  isMessage: function isMessage(message) {
    var types = ['privmsg', 'action', 'notice', 'message'];
    return types.indexOf(message.type) > -1;
  },
  isSystemMessage: function isSystemMessage(message) {
    if (!message) {
      return true;
    }
    return !this.isMessage(message) || message.type === 'traffic' || message.type === 'topic' || message.type === 'error';
  },
  displayAvatar: function displayAvatar(message) {
    var props = this.props;
    if (!message || !message.nick) {
      return false;
    }
    if (!this.isMessage(message)) {
      return false;
    }
    if (props.ml.buffer.isServer() || props.ml.buffer.isSpecial()) {
      return false;
    }
    return true;
  },
  userMode: function userMode(user) {
    var props = this.props;
    return props.ml.buffer.userMode(user);
  },
  userModePrefix: function userModePrefix(user) {
    var props = this.props;
    return props.ml.buffer.userModePrefix(user);
  },
  normalizeNick: function normalizeNick(value) {
    var _context;
    return (0, _trim.default)(_context = String(value || '').replace(/(?:\u2B50|\uD83C[\uDF08\uDF38]|\uD83D[\uDD7A\uDE42\uDEE1])/g, '').replace(/\uFE0F/g, '').replace(/^[@+~&%]+/, '')).call(_context).toLowerCase();
  },
  cleanVisibleNick: function cleanVisibleNick(value) {
    var _context2;
    return (0, _trim.default)(_context2 = String(value || '').replace(/(?:\u2B50|\uD83C[\uDF08\uDF38]|\uD83D[\uDD7A\uDE42\uDEE1])/g, '').replace(/\uFE0F/g, '').replace(/^[@+~&%]+/, '')).call(_context2);
  },
  cleanVisibleRealName: function cleanVisibleRealName(value) {
    var _context3;
    return (0, _trim.default)(_context3 = String(value || '').replace(/\|g:[hmno]/ig, '').replace(/\s*CL-[a-z0-9]{2,12}\s*/ig, ' ').replace(/\s+/g, ' ')).call(_context3);
  },
  emojiFromRealName: function emojiFromRealName(realname) {
    var text = String(realname || '');
    var lower = text.toLowerCase();
    var marker = lower.match(/\|g:([hmno])/);
    if (marker && marker[1] === 'h') {
      return '🕺';
    }
    if (marker && marker[1] === 'm') {
      return '🌸';
    }
    if (marker && marker[1] === 'o') {
      return '🌈';
    }
    if (marker && marker[1] === 'n') {
      return '🙂';
    }
    for (var i = 0; i < profileEmojis.length; i++) {
      if (text.indexOf(profileEmojis[i]) !== -1) {
        return profileEmojis[i] === '🛡' ? '🛡️' : profileEmojis[i];
      }
    }
    return '';
  },
  emojiFromLocalStorage: function emojiFromLocalStorage(nick) {
    if (typeof window === 'undefined' || !window.localStorage) {
      return '';
    }
    var key = this.normalizeNick(nick);
    if (!key) {
      return '';
    }
    var savedNick = '';
    var savedGender = '';
    try {
      savedNick = this.normalizeNick(window.localStorage.getItem('chatlatinos_gender_nick') || '');
      savedGender = String(window.localStorage.getItem('chatlatinos_gender') || '').toLowerCase();
    } catch (error) {}
    if (!savedGender || key !== savedNick) {
      return '';
    }
    if (savedGender === 'h') {
      return '🕺';
    }
    if (savedGender === 'm') {
      return '🌸';
    }
    if (savedGender === 'o') {
      return '🌈';
    }
    if (savedGender === 'n') {
      return '🙂';
    }
    return '';
  },
  emojiFromGlobalProfile: function emojiFromGlobalProfile(nick) {
    if (typeof window === 'undefined' || !window.chatlatinosProfiles) {
      return '';
    }
    var key = this.normalizeNick(nick);
    if (!key) {
      return '';
    }
    if (typeof window.chatlatinosProfiles.getEmoji === 'function') {
      var emoji = window.chatlatinosProfiles.getEmoji(key);
      if (emoji) {
        return emoji;
      }
    }
    if (window.chatlatinosProfiles.byNick && window.chatlatinosProfiles.byNick[key]) {
      return window.chatlatinosProfiles.byNick[key].emoji || '';
    }
    return '';
  },
  emojiFromMode: function emojiFromMode(message) {
    if (!message || !message.user) {
      return '';
    }
    var mode = this.userMode(message.user);
    if (['q', 'a', 'o', 'h'].indexOf(mode) !== -1) {
      return '🛡️';
    }
    if (mode === 'v') {
      return '⭐';
    }
    return '';
  },
  chatlatinosEmoji: function chatlatinosEmoji(message) {
    if (!message) {
      return '🙂';
    }
    var modeEmoji = this.emojiFromMode(message);
    if (modeEmoji) {
      return modeEmoji;
    }
    var localEmoji = this.emojiFromLocalStorage(message.nick);
    if (localEmoji) {
      return localEmoji;
    }
    var globalEmoji = this.emojiFromGlobalProfile(message.nick);
    if (globalEmoji) {
      return globalEmoji;
    }
    var realnameEmoji = message.user ? this.emojiFromRealName(message.user.realname) : '';
    if (realnameEmoji) {
      return realnameEmoji;
    }
    return '🙂';
  }
};
var _default = exports.default = {
  inject: {
    components: {
      default: {
        UserAvatar: _UserAvatar.default,
        MessageInfo: _MessageInfo.default,
        AwayStatusIndicator: _AwayStatusIndicator.default,
        MediaViewer: _MediaViewer.default
      }
    }
  },
  props: {
    ml: Object,
    message: Object,
    idx: Number,
    m: {
      default: function m() {
        return function n() {
          methods.props = this;
          return methods;
        };
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageModern"]
window._kiwi_exports.components.MessageListMessageModern = exports.default ? exports.default : exports;
